@if (service()) {
  <span class="assignment-host">
    @if (workerLink(); as link) {
      <a [routerLink]="link" (click)="$event.stopPropagation()"><strong>{{ service() }}</strong></a>
    } @else {
      <strong>{{ service() }}</strong>
    }
    @if (host()) {
      <small>{{ host() }}</small>
    }
    @if (version()) {
      <small>{{ version() }}</small>
    }
  </span>
} @else if (fallback() === 'Monolith') {
  {{ 'Monolith' | translate }}
} @else {
  {{ fallback() || '—' }}
}
